import React from 'react';
import { MapContainer, Marker, TileLayer } from 'react-leaflet';
import { Browser, divIcon } from 'leaflet';
import 'leaflet/dist/leaflet.css';
const markerIcon = divIcon({
    html: '<zds-map-marker><zds-icon name="home" /></zds-map-marker>',
    iconSize: [40, 40],
    className: '',
});
export const DetailMap = ({ latitude, longitude, height = '500px', width = '100%' }) => (React.createElement(MapContainer, { center: [latitude, longitude], zoom: 16, scrollWheelZoom: false, dragging: !Browser.mobile, style: { height: height, width: width } },
    React.createElement(TileLayer, { attribution: '\u00A9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors', url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
    React.createElement(Marker, { position: [latitude, longitude], icon: markerIcon, keyboard: false })));
